import MigrationDetailsEditContainer from "internal/programs/migration-acceleration-program/2024/fund-request/components/edit/MigrationDetailsEditContainer/MigrationDetailsEditContainer";

export default MigrationDetailsEditContainer;
